/**
 * On products with a large, sparse variant matrix (e.g. combined offcut
 * listings with dozens of colors), most color + other-option combinations
 * don't exist as real variants - each color is really its own one-off item
 * with its own Size/Type. Picking such a color leaves the currently
 * selected Size/Type stuck on a value that doesn't exist for the new
 * color, so the theme can't resolve a variant at all and nothing updates.
 *
 * Rather than reimplement the theme's AJAX variant-change flow, this
 * auto-corrects the other option inputs (e.g. Size) to a value that's
 * actually available for the newly selected color, then re-fires the
 * change event so the theme's own (already working) update logic runs
 * normally - no page reload, no custom fetch/swap code.
 *
 * Only engages for radio/checkbox-style pickers (swatches, buttons). If any
 * option on the product uses a dropdown, this backs off entirely rather
 * than risk a partially-applied correction.
 */
(function () {
  function getPosition(name) {
    var match = name.match(/-(\d+)$/);
    return match ? parseInt(match[1], 10) : null;
  }

  function currentComboKey(variantSelects) {
    if (variantSelects.querySelector('[data-popout-input]')) return null;

    // Always a fixed 3 slots (options beyond what this product has stay
    // empty strings) to match the server's option1|option2|option3 format,
    // regardless of how many options this product actually defines.
    var values = ['', '', ''];
    var foundAny = false;

    variantSelects.querySelectorAll('input[type="radio"]:checked, input[type="checkbox"]:checked').forEach(function (input) {
      var position = getPosition(input.name);
      if (position === null || position > 3) return;
      values[position - 1] = input.value;
      foundAny = true;
    });

    if (!foundAny) return null;

    return values.join('|');
  }

  function selectRadioValue(variantSelects, position, value) {
    var inputs = variantSelects.querySelectorAll('input[type="radio"], input[type="checkbox"]');
    for (var i = 0; i < inputs.length; i++) {
      var input = inputs[i];
      if (getPosition(input.name) === position && input.value === value) {
        input.checked = true;
        return true;
      }
    }
    return false;
  }

  function init(productInfo) {
    var variantSelects = productInfo.querySelector('variant-selects');
    var mapEl = productInfo.querySelector('[data-color-media-fallback]');
    if (!variantSelects || !mapEl) return;

    var colorOptionName = mapEl.dataset.colorOptionName;
    var colorOptionKey = mapEl.dataset.colorOptionKey;
    if (!colorOptionName || !colorOptionKey) return;

    var colorPosition = parseInt(colorOptionKey.replace('option', ''), 10);
    if (!colorPosition) return;

    var data = {};
    try {
      data = JSON.parse(mapEl.textContent);
    } catch (error) {
      return;
    }

    var comboMap = data.combos || {};
    var colorOptionsMap = data.colorOptions || {};
    var namePrefix = colorOptionName + '-';

    variantSelects.addEventListener(
      'change',
      function (event) {
        var target = event.target;
        if (!target || !target.name || target.name.indexOf(namePrefix) !== 0) return;

        var comboKey = currentComboKey(variantSelects);
        if (comboKey === null || Object.prototype.hasOwnProperty.call(comboMap, comboKey)) return;

        var correctedOptions = colorOptionsMap[target.value];
        if (!correctedOptions) return;

        var appliedAll = true;
        correctedOptions.forEach(function (value, index) {
          var position = index + 1;
          if (position === colorPosition) return;
          if (!selectRadioValue(variantSelects, position, value)) appliedAll = false;
        });

        if (!appliedAll) return;

        // This change event reflects a now-stale (invalid) combination -
        // stop it here and re-fire a corrected one below instead.
        event.stopImmediatePropagation();

        target.dispatchEvent(new Event('change', { bubbles: true }));
      },
      true
    );
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('product-info').forEach(init);
  });
})();
